// The one recency interleave: dated CARDS slotted into an ordered list of ROWS that is never re-sorted. Shared by
// the island's orange card (outreach-only questions among the task cards) and the Tasks screen's Action needed
// tab (outreach questions and open asks among the task rows), so the two place a card by the same rule. Mirrored
// 1:1 by iOS / Android `interleaveByRecency`.
//
// The cards go newest first (a stable sort: ties keep their input order). A card goes in front of a row only when
// it is STRICTLY newer than that row (a tie keeps the row first); a row with no time reads as the epoch; a card
// with no time goes after every row. Pure.

/** An ISO stamp (or Date) as a number; absent or unparseable → `undefined`. */
export function isoMs(iso: string | Date | undefined): number | undefined {
  if (!iso) return undefined;
  const ms = iso instanceof Date ? iso.getTime() : Date.parse(iso);
  return Number.isNaN(ms) ? undefined : ms;
}

export function interleaveByRecency<R, C>(
  rows: R[],
  rowAt: (row: R) => string | Date | undefined,
  cards: C[],
  cardAt: (card: C) => string | Date | undefined,
): (R | C)[] {
  const dated = cards
    .map((card, index) => ({ card, index, ms: isoMs(cardAt(card)) }))
    .sort((a, b) => (b.ms ?? -Infinity) - (a.ms ?? -Infinity) || a.index - b.index);
  const merged: (R | C)[] = [];
  let next = 0;
  for (const row of rows) {
    const rowMs = isoMs(rowAt(row)) ?? 0;
    while (next < dated.length && dated[next].ms !== undefined && (dated[next].ms as number) > rowMs) {
      merged.push(dated[next].card);
      next += 1;
    }
    merged.push(row);
  }
  for (; next < dated.length; next += 1) merged.push(dated[next].card);
  return merged;
}
